export default __webpack_public_path__ + "static/media/controller.5a6c112c.svg";